import get from 'lodash/get';
/** import third-party libraries in the section above, Sort Lines Ascending */

export default function selector(storeState) {
    return {
        profile: get(storeState, 'profile', {}),
    };
}
